<script lang="ts">
// import CriteriaValueTypeContentFactory from 'frontend/common/data-tables/search-criteria/factories/CriteriaValueTypeContentFactory.vue'
// import CriteriaValueTypeInputFactory from 'frontend/common/data-tables/search-criteria/factories/CriteriaValueTypeInputFactory.vue'
import CriteriaValueTypeInputFactory from 'frontend/common/data-tables/search-criteria/factories/CriteriaValueTypeInputFactory.vue'
import CriteriaValueTypePreviewFactory from 'frontend/common/data-tables/search-criteria/factories/CriteriaValueTypePreviewFactory.vue'
import { getCriteriaValueTypeByConfig } from 'frontend/common/data-tables/search-criteria/functions/getCriteriaValueTypeByConfig'
import FormLabel from 'frontend/common/ea-form-controls/_form-label.vue'
import { predicateMappings } from 'frontend/common/search-criterion/_search-criterion-predicate-config.js'
import { useVariables } from 'frontend/variables/composables/useVariables'
import { camelCase, startCase } from 'lodash'
import { ref } from 'vue'
import { mapGetters } from 'vuex'
import { FilterXSS } from 'xss'

export default {
  name: 'SearchCriterionPreviewContainer',
  emits: ['remove-filter', 'update:modelValue', 'update:filters'],
  props: {
    filterValue: {
      type: [Object, Array, String, Number, Boolean],
    },
    filterKey: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    searchCriteria: {
      type: Object,
      required: true,
    },
    attributeNameClass: {
      type: [String, Object, Array],
      default: '',
    },
    predicateClass: {
      type: [String, Object, Array],
      default: '',
    },
    valueClass: {
      type: [String, Object, Array],
      default: '',
    },
    modelValue: {
      type: [Object, Array, String, Number, Boolean],
    },
  },
  data() {
    return {
      fetchedHumanizedValues: null,
      sanitizer: new FilterXSS({
        whiteList: {
          i: ['class'],
          b: ['class'],
          span: ['class'],
          div: ['class'],
        },
      }),
    }
  },
  setup(props) {
    const { variableByIdMap } = useVariables()
    const localFilters = ref({
      ...props.filters,
    })
    return {
      variableByIdMap,
      localFilters,
      predicateMappings,
    }
  },
  computed: {
    ...mapGetters('currentContext', ['currentEvent']),
    startCasedFilterKey() {
      return startCase(this.filterKey)
    },
    // tooltipText() {
    //   let result = this.criteriaPath.map(el => el.label).join('<i class="bi-arrow-right"></i>')
    //   const humanizedValuesHtml = this.humanizedValues
    //     .map(el => {
    //       return el.isHtml ? this.sanitizer.process(el.label) : el.label
    //     })
    //     .join(', ')
    //   result += ` ${this.humanizedPredicate} ${humanizedValuesHtml}`
    //   return this.sanitizer.process(result)
    // },
    criteriaValueType() {
      return getCriteriaValueTypeByConfig(this.criterion, this.predicate)
    },

    criteriaPath() {
      return this.findCriteriaPath(this.searchCriteria)
    },
    criterion() {
      return this.criteriaPath[this.criteriaPath.length - 1]
    },
    predicate() {
      if (this.criterion) {
        return this.criterion.predicates.find(
          p => this.filterKey == this.buildFilterKey(this.criterion.key, p),
        )
      }
      return null
    },
    humanizedPredicate() {
      if (this.criterion) {
        const predicate = this.criterion.predicates.find(
          p => this.filterKey == this.buildFilterKey(this.criterion.key, p),
        )
        if (predicate) {
          return (
            predicateMappings[predicate]?.humanized || predicateMappings[predicate]?.name || '??'
          )
        }
      }
      return '??'
    },
    filterValueModel: {
      get() {
        return this.filterValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
  },
  watch: {
    filters: {
      handler(value) {
        this.localFilters = { ...value }
      },
      immediate: true,
    },
  },
  methods: {
    buildFilterKey(key, predicate) {
      return camelCase(`${key}_${predicate}`)
    },
    findCriteriaPath(criteriaAtLevel) {
      const potentialKey = Object.keys(criteriaAtLevel).find(k => {
        return (
          this.filterKey.startsWith(k) &&
          !!criteriaAtLevel[k]?.predicates?.find(el => this.buildFilterKey(k, el) == this.filterKey)
        )
      })
      if (potentialKey) {
        return [{ ...criteriaAtLevel[potentialKey], key: potentialKey }]
      }

      let result = []
      Object.keys(criteriaAtLevel).some(k => {
        if (criteriaAtLevel[k].children) {
          const subResult = this.findCriteriaPath(criteriaAtLevel[k].children)
          if (subResult?.length) {
            result = [{ ...criteriaAtLevel[k], key: k }, ...subResult]
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      })

      return result
    },
    valueChanged(newVal) {
      if (typeof newVal === 'undefined' || (Array.isArray(newVal) && newVal.length === 0)) {
        delete this.localFilters[this.filterKey]
      } else {
        this.localFilters[this.filterKey] = newVal
      }
    },
    save(callbackFn) {
      this.$emit('update:filters', this.localFilters)
      callbackFn()
    },
    cancel(callbackFn) {
      this.localFilters = {
        ...this.filters,
      }
      if (callbackFn) {
        callbackFn()
      }
    },
  },
  components: {
    FormLabel,
    CriteriaValueTypeInputFactory,
    CriteriaValueTypePreviewFactory,
  },
}
</script>

<template lang="pug">
.d-inline-flex
  dropdown(
    @hidden="cancel"
    customClass="wide-popover small-paddings"
    doNotRemoveContent
    placement="bottom"
    strategy="fixed"
    triggerClass="popover-trigger"
  )
    .used-filter.align-items-center.justify-content-start(v-show="searchCriteria")
      .filter-content.popover-trigger.cursor-pointer
        span(v-if="!criteriaPath?.length" :class="attributeNameClass") {{ startCasedFilterKey }}
        div
          span.criterion-label(
            v-for="(criterionPathItem, i) in criteriaPath"
            :class="attributeNameClass"
            :key="i"
          )
            //- i.bi-arrow-right(v-if="i > 0")
            | {{ i > 0 ? ' ' : '' }}
            | {{ criterionPathItem.label }}
        .value-wrapper(:class="predicateClass")
          .values(:class="valueClass")
            CriteriaValueTypePreviewFactory(
              :criteriaValueType="criteriaValueType"
              :criterion="criterion"
              :humanizedPredicate="humanizedPredicate"
              :predicate="predicate"
              v-model="filterValueModel"
            )
      .actions
        slot(name="actions")
          i.fa.fa-times.ms-1(@click="$emit('remove-filter')")
    template(#items="{ close }")
      .quick-filter-edit-form
        div
          .title
            span.criterion-label(
              v-for="(criterionPathItem, i) in criteriaPath"
              :class="attributeNameClass"
              :key="i"
            )
              //- i.bi-arrow-right(v-if="i > 0")
              | {{ i > 0 ? ' ' : '' }}
              | {{ criterionPathItem.label }}
          FormLabel(:label="predicateMappings[predicate].name")
          CriteriaValueTypeInputFactory(
            :criteriaValueType="criteriaValueType"
            :criterion="criterion"
            :key="filterKey"
            :modelValue="localFilters[filterKey]"
            :name="`filters.${filterKey}`"
            :predicate="predicate"
            @update:modelValue="valueChanged($event)"
          )
        .actions.d-flex.justify-content-end.gap-2
          .btn.btn-text.btn-md(@click="cancel(close)") Cancel
          .btn.btn-outline-danger.btn-md(@click="$emit('remove-filter')") Clear
          .btn.btn-primary.btn-md(@click="save(close)") Set
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.filter-content {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.quick-filter-edit-form {
  padding: 16px 24px;
  display: grid;
  gap: 16px;
  max-width: 420px;

  .title {
    font-size: 16px;
    font-weight: 600;
    padding: 0;
  }
}

.merged-input-title :deep(.line) {
  background: map.get(themeVariables.$colors, containerLowest);
}
</style>
